var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("app-select-bank-type", {
        attrs: {
          value: _vm.singleValue,
          label: _vm.label,
          fancy: "",
          "use-ids": "",
        },
        on: {
          input: function ($event) {
            return _vm.setSingleValue($event)
          },
        },
      })
    : _c("app-multi-select-bank-type", {
        attrs: {
          value: _vm.multiValue,
          label: _vm.label,
          fancy: "",
          "use-ids": "",
        },
        on: {
          input: function ($event) {
            return _vm.setMultiValue($event)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }